<template>
  <div>
    <div class="row mt-4">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="header-title mt-0 mb-1">Data {{ title }}</h4>
            <p class="sub-header">
              {{ subtitle }}
            </p>
            <div class="jpsListControls">
              <div class="jpsListSearch">
                <div class="dropdown-float width-200-px">
                  <span>Baris per halaman</span>
                  <b-form-select
                    v-model="perPage"
                    :options="optionPerPage"
                  ></b-form-select>
                </div>
                <div class="input-group-custom search-input flex-fill">
                  <input
                    v-model="qCari"
                    type="text"
                    class="form-control"
                    placeholder="Cari data JPS..."
                  />
                  <feather
                    type="search"
                    size="18"
                    class="search-icon"
                  ></feather>
                </div>
              </div>
              <b-dropdown right variant="primary" no-caret>
                <template v-slot:button-content>
                  <i class="fa fa-cogs"></i> Aksi JPS
                </template>
                <b-dropdown-item v-if="checkAuthorizedAll" :to="`${routes}/add`">
                  <i class="uil uil-plus-circle mr-2"></i> Buat data JPS
                </b-dropdown-item>
                <b-dropdown-item @click="downloadJps(null)">
                  <i class="uil uil-download-alt mr-2"></i> Export data
                </b-dropdown-item>
                <b-dropdown-item @click="getList">
                  <i class="uil uil-sync mr-2"></i> Muat ulang
                </b-dropdown-item>
              </b-dropdown>
            </div>
            <div class="jpsTableWrapper">
              <table class="jpsTable">
                <thead>
                  <tr>
                    <th
                      v-for="(field, index) in tableFields"
                      :key="field.key"
                      :class="tableColumnClass(field.key, index)"
                    >
                      {{ field.label }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, itemIndex) in items" :key="item.id">
                    <td
                      v-for="(field, index) in tableFields"
                      :key="field.key"
                      :class="tableColumnClass(field.key, index)"
                    >
                      <div
                        v-if="field.key === 'id'"
                        class="jpsTableActions"
                      >
                        <router-link
                          :to="`${routes}/${item.id}`"
                          class="btn btn-sm btn-outline-primary p-1"
                          title="Detail"
                        >
                          <i class="uil uil-eye"></i>
                        </router-link>
                        <router-link
                          v-if="checkAuthorizedAll"
                          :to="`${routes}/${item.id}/edit`"
                          class="btn btn-sm btn-outline-primary p-1"
                          title="Edit"
                        >
                          <i class="uil uil-edit-alt"></i>
                        </router-link>
                        <button
                          class="btn btn-sm btn-outline-primary p-1"
                          type="button"
                          title="Export"
                          @click="downloadJps(item.id)"
                        >
                          <i class="uil uil-download-alt"></i>
                        </button>
                        <button
                          v-if="checkAuthorizedAll"
                          class="btn btn-sm btn-outline-danger p-1"
                          type="button"
                          title="Hapus"
                          :disabled="item.is_approved"
                          @click="deleteJps(item.id)"
                        >
                          <i class="uil uil-trash"></i>
                        </button>
                      </div>
                      <div v-else>
                        {{ renderFieldValue(item, field, itemIndex) }}
                      </div>
                    </td>
                  </tr>
                  <tr v-if="items.length === 0">
                    <td
                      :colspan="tableFields.length"
                      class="text-center text-muted py-5"
                    >
                      Tidak ada data JPS yang ditemukan.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <p>Data {{ from }} ke {{ to }} dari {{ total }} data</p>
              </div>
              <div class="col-sm-12 col-md-6">
                <div class="text-md-right">
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    first-text="First"
                    prev-text="Prev"
                    next-text="Next"
                    last-text="Last"
                    class="d-inline-flex"
                    @input="getList"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { canManage } from '@utils/permissions'
import { crudMethods } from '@state/helpers'

export default {
  name: 'JpsList',
  props: {
    user: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    url: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
    crumbs: {
      type: Array,
      default: () => {
        return []
      },
    },
    fields: {
      type: Array,
      default: () => {
        return []
      },
    },
    model: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data: () => {
    return {
      baseURL: process.env.VUE_APP_API_ENDPOINT,
      routes: '/transaksi/jps',
      pkId: null,
      rows: 1,
      qCari: '',
      perPage: 25,
      optionPerPage: [
        { value: 15, text: 15 },
        { value: 25, text: 25 },
        { value: 50, text: 50 },
        { value: 100, text: 100 },
      ],
      currentPage: 1,
      total: 1,
      from: 1,
      to: 1,
      items: [],
    }
  },
  computed: {
    tableFields() {
      return [{ key: 'no', label: 'No' }, ...this.fields]
    },
    checkAuthorizedAll() {
      return canManage(this.user, 'transaksi.jps')
    },
  },
  watch: {
    items: {
      handler: function (newVal, oldval) {
        for (var i = 0; i < newVal.length; i++) {
          this.items[i]['no'] = i + this.from
        }
      },
      deep: true,
    },
    qCari: {
      handler: function (newVal, oldval) {
        if (newVal.length > 3 || newVal.length === 0) {
          this.getList()
        }
      },
    },
    perPage: {
      handler: function (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.currentPage = 1
          this.getList()
        }
      },
    },
  },
  mounted() {
    this.getList()
  },
  methods: {
    ...crudMethods,
    tableColumnClass(key, index) {
      return {
        stickyCol: index === 0,
        stickyColRight: key === 'id',
        textCenter: key === 'no' || key === 'id',
      }
    },
    renderFieldValue(item, field, index) {
      if (field.key === 'no') {
        return (this.currentPage - 1) * this.perPage + index + 1
      }
      if (
        field.key === 'status_kabid_kemitraan' ||
        field.key === 'status_sekretaris' ||
        field.key === 'status_ketua'
      ) {
        return item[field.key] || 'MENUNGGU'
      }
      if (typeof field.formatter === 'function') {
        return field.formatter(item[field.key], field.key, item)
      }
      return item[field.key] !== undefined && item[field.key] !== null
        ? item[field.key]
        : '-'
    },
    getList() {
      this.listData({
        url: `${this.url}?page=${this.currentPage}&q=${this.qCari}&per_page=${this.perPage}`,
      }).then((response) => {
        this.items = []
        const data = response.data.data
        const meta = response.data.meta

        this.rows = meta.total
        this.perPage = meta.per_page
        this.currentPage = meta.current_page
        this.from = meta.from
        this.to = meta.to
        this.total = meta.total

        this.items = data
      })
    },
    downloadJps(id) {
      this.downloadData({
        url: id ? `web/export/jps/${id}/export` : 'web/export/jps/export',
      }).then((response) => {
        // console.log(response)
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', id ? `jps-${id}.pdf` : 'list-jps.xlsx')
        document.body.appendChild(link)
        link.click()
      })
    },
    deleteJps(id) {
      if (!this.checkAuthorizedAll) return
      if (!confirm('Apakah Anda yakin?')) {
        return
      }

      const self = this
      const url = `web${this.routes}/${id}`
      this.deleteData({ url: url })
        .then(function (response) {
          self.getList()
          self.toast('b-toaster-bottom-right', true, 'Data berhasil dihapus')
        })
        .catch(function (error) {
          console.error(error)
          self.toast(
            'b-toaster-bottom-right',
            true,
            'Data gagal dihapus',
            'error'
          )
        })
    },
    toast(toaster, append = false, body, variant = 'success') {
      this.counter++
      this.$bvToast.toast(body, {
        title: this.title,
        toaster: toaster,
        solid: true,
        appendToast: append,
        variant: variant,
      })
    },
  },
}
</script>

<style scoped>
.jpsListControls {
  display: flex;
  flex: 1;
  align-items: flex-end;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;
}

.jpsListSearch {
  display: flex;
  flex: 1;
  align-items: flex-end;
  gap: 0.75rem;
}

.jpsTableWrapper {
  width: 100%;
  max-height: 75vh;
  overflow: auto;
  border: 1px solid #dee2e6;
}

.jpsTable {
  width: 100%;
  min-width: 1900px;
  font-size: 13px;
  border-spacing: 0;
  border-collapse: separate;
}

.jpsTable th,
.jpsTable td {
  padding: 8px 12px;
  white-space: nowrap;
  vertical-align: middle;
  background: #fff;
  border-right: 1px solid #dee2e6;
  border-bottom: 1px solid #dee2e6;
}

.jpsTable th {
  position: sticky;
  top: 0;
  z-index: 20;
  font-weight: 600;
  background-color: #f8f9fa;
  border-top: 1px solid #dee2e6;
}

.jpsTable .stickyCol,
.jpsTable .stickyColRight {
  position: sticky;
  z-index: 10;
  background: #fff;
  box-shadow: 4px 0 6px -2px rgba(0, 0, 0, 0.08);
}

.jpsTable th.stickyCol,
.jpsTable th.stickyColRight {
  z-index: 30;
  background-color: #f8f9fa;
}

.jpsTable th:first-child,
.jpsTable td:first-child {
  border-left: 1px solid #dee2e6;
}

.jpsTable .stickyCol {
  left: 0;
  min-width: 55px;
  text-align: center;
}

.jpsTable .stickyColRight {
  right: 0;
  min-width: 150px;
  box-shadow: -4px 0 6px -2px rgba(0, 0, 0, 0.08);
}

.jpsTable tbody tr:hover td,
.jpsTable tbody tr:hover .stickyCol,
.jpsTable tbody tr:hover .stickyColRight {
  background-color: #f8f9fa;
}

.jpsTable .textCenter {
  text-align: center;
}

.jpsTableActions {
  display: flex;
  justify-content: center;
  gap: 0.35rem;
}

.jpsTableWrapper::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

.jpsTableWrapper::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}

.jpsTableWrapper::-webkit-scrollbar-track {
  background: #f8fafc;
}

@media (max-width: 767.98px) {
  .jpsListControls,
  .jpsListSearch {
    flex-direction: column;
    align-items: stretch;
  }

  .jpsListControls {
    align-items: flex-start;
  }
}
</style>